import { action, autorun, makeAutoObservable, runInAction } from "mobx";
import { observer } from "mobx-react";
import { h, render } from "preact";
import { Tracking, debugAvailabilityErrors, makeImmutable, } from "restaumatic-client";
import * as Modals from "../../utils/Modals";
import Creator from "./Creator";
import { scrollToError } from "../../utils/Scroll";
import { findMenuItemButton } from "../../utils/findMenuItemButton";
import * as CrossSellingAddToCartBottomSheet from "../../components/CrossSellingAddToCartBottomSheet";
import FieldTests from "../../utils/FieldTests";
import { addToCartCrossSellingBottomSheet } from "../../utils/FieldTests/experiments/AddToCartCrossSellingBottomSheet";
export function init(cartIntegration, crossSellingAddToCartBottomSheet) {
    console.log("Initializing new ProductCard");
    const state = new ModalState();
    const modalElement = state.createModalElement(Modals.CREATOR_MODAL_ID);
    render(h(CreatorModal, { state: state }), modalElement);
    return (productCardCreator, element) => {
        runInAction(() => {
            state.productCard = new ProductCard({
                cartIntegration,
                creator: productCardCreator,
                crossSellingAddToCartBottomSheet,
            });
            state.productCard.show(element);
        });
    };
}
class ModalState {
    constructor() {
        this.isOpen = false;
        this.productCard = null;
        makeAutoObservable(this);
        // FIXME for some reason MobX when does not work properly (only runs once and then never evaluates again)
        autorun(() => {
            if (this.isOpen && this.productCard !== null) {
                const { creator } = this.productCard;
                switch (creator.openIntent) {
                    case "add_from_menu":
                        history.replaceState(null, "", window.location.pathname + ModalState.hash(creator));
                        break;
                    case "add_from_cart":
                    case "edit_from_cart":
                        history.replaceState(null, "", window.location.pathname +
                            `${Modals.CART_MODAL_PREFIX}${Modals.CART_MODAL_ID}`);
                        break;
                }
            }
        });
    }
    static hash(creator) {
        return `${Modals.CREATOR_HASH_PREFIX}${creator.productTypeIdValues.join("/")}`;
    }
    createModalElement(id) {
        const modalElement = document.createElement("div");
        modalElement.id = id;
        modalElement.classList.add("m-product-card", "modal", "fade");
        modalElement.tabIndex = -1;
        modalElement.addEventListener("show.bs.modal", action(() => {
            this.isOpen = true;
        }));
        modalElement.addEventListener("hide.bs.modal", action(() => {
            this.isOpen = false;
        }));
        document.body.appendChild(modalElement);
        return modalElement;
    }
}
export class ProductCard {
    constructor(params) {
        this.cartIntegration = params.cartIntegration;
        this.creator = params.creator;
        this.crossSellingAddToCartBottomSheet =
            params.crossSellingAddToCartBottomSheet;
        makeImmutable(this);
    }
    show(element) {
        void Modals.showModal(Modals.CREATOR_MODAL_ID, element).then((res) => {
            // NOTICE show cart when creator was dismissed without adding anything to cart
            return res === null || res === void 0 ? void 0 : res.hidden.then(() => {
                switch (this.creator.openIntent) {
                    case "add_from_cart":
                    case "edit_from_cart":
                        return Modals.showModal(Modals.CART_MODAL_ID);
                    case "add_from_menu":
                        break;
                }
            });
        });
    }
    addToCart() {
        const result = this.creator.finish();
        if (result === null) {
            this.scrollToError();
            return;
        }
        Modals.setNextModalShouldReplaceHash();
        // TODO: switch to async/await once transpilation is sorted out
        void Modals.hideModal(Modals.CREATOR_MODAL_ID).then(action(() => {
            this.cartIntegration.addToCart(result);
            const menuItemButton = findMenuItemButton(result.orderLines.get(0).productTypeIds.toString());
            // Show Cart on the active menu because the Cart button is not sticky and could be hard to find
            if (this.creator.openIntent === "add_from_menu" &&
                Skubacz.configuration.theme_name === "active_menu") {
                return Modals.showModal(Modals.CART_MODAL_ID, menuItemButton);
            }
            // Show CrossSelling A/B test
            FieldTests.apply(addToCartCrossSellingBottomSheet);
            const variant = FieldTests.getVariant(addToCartCrossSellingBottomSheet);
            if (variant === "Test" && this.creator.openIntent === "add_from_menu") {
                this.crossSellingAddToCartBottomSheet.setInputProductTypeIds(this.creator.domain.productTypeIds);
                if (this.crossSellingAddToCartBottomSheet.crossSellingItems.length > 0) {
                    return Modals.showModal(CrossSellingAddToCartBottomSheet.CROSS_SELLING_ADD_TO_CART_BOTTOM_SHEET_ID, menuItemButton);
                }
            }
        }));
    }
    scrollToError() {
        scrollToError(`#${Modals.CREATOR_MODAL_ID}`, [
            ".m-alert--danger",
            ".m-alert--warning",
            ".has-error",
            ".m-badge--error",
        ]);
        Tracking.trackEvent({
            tag: "ProductCardAvailabilityError",
            contents: {
                restaurantId: this.creator.restaurantId.value,
                name: this.creator.product.name,
                productIds: this.creator.productTypeIdValues,
                totalPrice: this.creator.priceValue,
                errors: debugAvailabilityErrors(this.creator.availability),
            },
        });
    }
}
const CreatorModal = observer(({ state }) => {
    return (h("div", { className: "modal-dialog" },
        h("div", { className: "modal-content" }, state.productCard ? h(Creator, { productCard: state.productCard }) : null)));
});
